import React, { useState, useRef } from 'react';
import { GoogleMap, LoadScript, Polyline } from '@react-google-maps/api';
import './MapGenerator.css';

const containerStyle = {
  width: '100vw',
  height: '100vh',
  position: 'relative',
};

// Fallback constant defined outside
const DEFAULT_CENTER = { lat: 31.9275, lng: -81.0425 };

const MapGenerator = () => {
  const [paths, setPaths] = useState([]);
  const [watching, setWatching] = useState(false);
  const watchIdRef = useRef(null);

  // FIX: Moved dynamic center calculation inside the component
  // so it has access to 'paths' state.
  const mapCenter = paths.length > 0 && paths[paths.length - 1].length > 0
    ? paths[paths.length - 1][paths[paths.length - 1].length - 1]
    : DEFAULT_CENTER;

  const startTracking = () => {
    if (navigator.geolocation) {
      setPaths((prev) => [...prev, []]); // Start new segment
      const id = navigator.geolocation.watchPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords;
          setPaths((prevPaths) => {
            const updated = [...prevPaths];
            const lastIndex = updated.length - 1;
            if (lastIndex >= 0) {
              updated[lastIndex] = [
                ...updated[lastIndex],
                { lat: latitude, lng: longitude }
              ];
            }
            return updated;
          });
        },
        (err) => console.error('GPS error:', err),
        { enableHighAccuracy: true, maximumAge: 1000, timeout: 10000 }
      );
      watchIdRef.current = id;
      setWatching(true);
    } else {
      alert('Geolocation not supported.');
    }
  };

  const stopTracking = () => {
    if (watchIdRef.current !== null) {
      navigator.geolocation.clearWatch(watchIdRef.current);
      watchIdRef.current = null;
      setWatching(false);
    }
  };

  const savePath = () => {
    fetch('/api/save-path', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: 'User Mapping ' + new Date().toISOString(),
        timestamp: new Date().toISOString(),
        path: paths,
      }),
    })
      .then((res) => res.json())
      .then(() => alert('Path saved!'))
      .catch((err) => console.error('Save failed:', err));
  };

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <div style={{ position: 'relative' }}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={mapCenter} // FIX: Uses the mapCenter calculated above
          zoom={17}
        >
          {paths.map((segment, i) => (
            <Polyline
              key={i}
              path={segment}
              options={{ strokeColor: 'red', strokeWeight: 5 }}
            />
          ))}
        </GoogleMap>
        <div style={controlsContainerStyle}>
          <button
            onClick={startTracking}
            style={btnStyle}
            disabled={watching}
          >
            {watching ? 'Tracking...' : 'Start Tracking'}
          </button>
          <button onClick={stopTracking} style={btnStyle} disabled={!watching}>
            Stop
          </button>
          <button onClick={savePath} style={btnStyle}>
            Save Path
          </button>
        </div>
      </div>
    </LoadScript>
  );
};

// Simple styles for the layout
const controlsContainerStyle = {
  position: 'absolute',
  top: '60px',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '10px',
  zIndex: 1,
};

const btnStyle = {
  padding: '10px 15px',
  fontSize: '16px',
  backgroundColor: '#111',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
};

export default MapGenerator;
